import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _30fpsSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"30fps_select"}/>
}
